import 'core-js';
import 'regenerator-runtime/runtime';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { setConfig } from 'react-hot-loader';
import Startup from './Startup';
import './style.css';

// Add promise for shimming
var a = new Promise((a) => a).finally();
ReactDOM.render(<Startup />, document.getElementById('root'));
setConfig({ reloadHooks: true });
